import {createSelector} from "reselect"
import {AppState} from "../../redux/reducers/rootReducer"
import {RefDbDataContext} from "../models/displayDataContext"
import {State} from "./refdb.state"
import {Item} from "../../core/models/Item"
import {ColumnWidth} from "../../@biocrates-common-repo/core/models/columnWidth"
import {TableFiltering} from "../../@biocrates-common-repo/core/models/tableFiltering"
import {TableSorting} from "../../@biocrates-common-repo/core/models/tableSorting"
import SortableTableData from "../../@biocrates-common-repo/core/models/sortableTableData"
import {getTableRowsFromData} from "../../@biocrates-common-repo/core/utils/tableUtils"
import {ContextTemplate} from "../../settings/redux/reducers/settings.state"
import GenerateTableType from "../../shared/enums/generateTableType"

// Settings

function getDefaultSorting(): TableSorting[] {
    return []
}

function selectDisplayDataSorting(state: AppState): TableSorting[] {
    return state.settings.general.sorting ?? getDefaultSorting()
}

function selectDisplayDataFiltering(state: AppState): TableFiltering[] {
    return state.settings.general.filtering
}

function selectDisplayDataColumnWidths(state: AppState): ColumnWidth[] {
    return state.settings.general.columnWidths
}

export function selectDisplayDataContextTemplates(
    state: AppState
): ContextTemplate[] {
    return state.settings.general.contextTemplates
}

// RefDB

export function isLoadingDisplayData(state: AppState) {
    return state.refDb.isLoadingDisplayData
}
export function isExporting(state: AppState) {
    return state.refDb.isExporting
}
export function speciesSelector(state: AppState): string[] {
    return state.refDb.displayData.contextValues.species
}
export function assaySelector(state: AppState): string[] {
    return state.refDb.displayData.contextValues.assay
}
export function materialsSelector(state: AppState): string[] {
    return state.refDb.displayData.contextValues.materials
}
export function projectsSelector(state: AppState): string[] {
    return state.refDb.displayData.contextValues.projects
}
export function classesSelector(state: AppState): string[] {
    return state.refDb.displayData.contextValues.classes
}
export function metabolitesSelector(state: AppState): Item[] {
    return state.refDb.displayData.contextValues.metabolites
}
export function variablesSelector(state: AppState): string[] {
    return state.refDb.displayData.contextValues.variables
}
export function existingVariablesSelector(state: AppState): string[] {
    return state.refDb.displayData.contextValues.existingVariables
}
export function valuesSelector(state: AppState): any {
    return state.refDb.displayData.contextValues.values
}

export function getDisplayRefDbDataRows(state: AppState): any {
    return state.refDb.displayData.data.rows
}
export function getDisplayDemographics(state: AppState): any {
    return state.refDb.displayData.data.demographics
}

export function getDisplayDataColumns(state: AppState): any[] {
    return state.refDb.displayData.data.analyteColumns
}

export function getDisplayData(state: AppState): any {
    return state.refDb.displayData
}

export function getShowHmdbId(state: AppState): any {
    return state.refDb.context.showHmdbId
}

export function getMatrices(state: AppState): any[] {
    return state.refDb.displayData.contextValues.matrices
}

export function getRefDbDataContext(state: AppState): RefDbDataContext {
    return state.refDb.context
}

export function getMultiContext(state: AppState): RefDbDataContext[] {
    return state.refDb.multiContext
}

export function getDisplayDataRows(state: AppState): any {
    return getDisplayData(state).data.rows
}

export function getContext(state: AppState): RefDbDataContext {
    return state.refDb.context
}

export function getGenerateTable(state: AppState): GenerateTableType {
    return state.refDb.generateTable
}

export const getSortableTableData = createSelector(
    [
        getDisplayDataColumns,
        getDisplayRefDbDataRows,
        selectDisplayDataSorting,
        selectDisplayDataFiltering,
        selectDisplayDataColumnWidths,
    ],
    (cols, rows, sorting, filtering, columnWidths) =>
        new SortableTableData(
            cols,
            getTableRowsFromData(rows),
            sorting,
            filtering,
            columnWidths
        )
)

export function getState(state: AppState): State {
    return state.refDb
}
